import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FeatureFlags, useFeatureFlag } from "../../feature-flag";
import { ROUTES } from "../../routes";
import { useProductSteps } from "./useProductSteps";
import { useProductStepsV2 } from "./useProductStepsV2";

const Home = () => {
  const navigate = useNavigate();
  const { isEnabled: isAgreementsShowTicksAccordingly } = useFeatureFlag(
    FeatureFlags.EG_4656
  );
  const { productSteps, isLoading: isLoadingProductSteps } = useProductSteps(
    isAgreementsShowTicksAccordingly
  );
  const { productSteps: productStepsV2, isLoading: isLoadingProductStepsV2 } =
    useProductStepsV2(isAgreementsShowTicksAccordingly);

  useEffect(() => {
    if (!isAgreementsShowTicksAccordingly) {
      if (isLoadingProductSteps) return;
      if (productSteps.length > 0) {
        navigate(`/${productSteps[0].name}`);
      } else {
        navigate(ROUTES.PROFILE);
      }
    }

    if (isAgreementsShowTicksAccordingly) {
      if (isLoadingProductStepsV2) return;
      if (productStepsV2.length > 0) {
        navigate(`/${productStepsV2[0].name}`, {
          state: productStepsV2[0].payload,
        });
      } else {
        navigate(ROUTES.PROFILE);
      }
    }
  }, [
    productSteps,
    isLoadingProductSteps,
    navigate,
    isAgreementsShowTicksAccordingly,
    productStepsV2,
    isLoadingProductStepsV2,
  ]);

  return <></>;
};

export { Home };
